<div [formGroup]="form" *ngIf="column">
  <sc-checkbox formControlName="checkbox" [isReadOnly]="isDisabled()"> </sc-checkbox>
</div>
